export const FeedingPlanType = {
  full_bowl: 'full_bowl',
  half_bowl: 'half_bowl',
  starter_box: 'starter_box',
  trial_box: 'trial_box',
  tyga_full_bowl: 'tyga_full_bowl',
  tyga_mixed_bowl: 'tyga_mixed_bowl',
  starter_box_7_days: 'starter_box_7_days',
  starter_box_14_days: 'starter_box_14_days',
  starter_box_half: 'starter_box_half',
  starter_box_1_week: 'starter_box_1_week',
  starter_box_half_1_week: 'starter_box_half_1_week',
  starter_box_quarter_2_week: 'starter_box_quarter_2_week',
  starter_box_full_1w_over_2w: 'starter_box_full_1w_over_2w',
  trial_box_7x200g: 'trial_box_7x200g',
  trial_box_14x200g: 'trial_box_14x200g',
  topper: 'topper',
  starter_box_topper: 'starter_box_topper',
} as const
export type FeedingPlanType = typeof FeedingPlanType[keyof typeof FeedingPlanType]

